import { render, staticRenderFns } from "./AdministrativePositionDetails.vue?vue&type=template&id=af246424&scoped=true"
import script from "./AdministrativePositionDetails.vue?vue&type=script&lang=js"
export * from "./AdministrativePositionDetails.vue?vue&type=script&lang=js"
import style0 from "./AdministrativePositionDetails.vue?vue&type=style&index=0&id=af246424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af246424",
  null
  
)

export default component.exports